export default __webpack_public_path__ + "src/images/packages/monte-vista-boutique-hotel/6740b41dec00e74b871ca1dfc5c41468-4.jpg";